import InfoTip, {P} from '../../../components/info-tip/info-tip';

const DateFormatInfo = function ({propName}: {propName: string}) {
  return (
    <InfoTip
      info={
        <section className={'w-[150px]'}>
          <P>{propName}格式：YYYY/MM/DD</P>
        </section>
      }
    />
  );
};

export default DateFormatInfo;
